import type { MetaData } from 'services/content/page/types/CoursePage'
import type * as EventModule from '../types/EventModule'

export default function eventModuleComponentParser(
  rawComponent: EventModule.Raw,
  metaData: MetaData,
): EventModule.Parsed {
  const { locationCard, eventCard } = rawComponent.eventModule
  const {
    contactText,
    registrationOpenStatusText,
    registrationStatusLabelText,
    registrationText,
    registrationWaitingStatusText,
    revalidationText,
    revalidationPrice,
    eventSummaryText,
  } = eventCard
  const { courseDetails } = metaData

  const {
    id,
    name,
    locationUrl,
    location,
    isOnlineSeminar,
    startDate,
    isWaitlisted,
    seminarUrl,
    currency,
    currencySymbol,
    status,
    language,
  } = courseDetails

  const isOpen = status === 'Active'
  const isAvailable = isOpen && (!isOnlineSeminar || !isWaitlisted)

  return {
    name: 'EventModule',
    props: {
      language,
      eventSummaryText,
      locationSummaryText: locationCard.locationSummaryText,
      currency,
      currencySymbol,
      registerLink: {
        text: eventCard.registerLink.text,
        url: seminarUrl,
      },
      registrationOpenStatusText,
      registrationStatusLabelText,
      registrationText,
      registrationWaitingStatusText,
      revalidationPrice,
      revalidationText,
      contactText,
      isAvailable,
      isWaitlisted,
      id,
      name,
      location,
      isOnlineSeminar,
      date: startDate,
      mapLinkText: locationCard.map.text,
      websiteLink: locationUrl
        ? {
            text: locationCard.website.text,
            url: locationUrl,
          }
        : undefined,
    },
  }
}
